
<div class="modal-container d-flex flex-column h-100">
  <div class="modal-header border-0 justify-content-between">
    <h1 class="modal-title text-center text-primary-color"> {{ isAddValue == true ? " Edit Certification" : " Add  Certification" }} </h1>
    <div class="hand d-flex align-items-center" (click)="clearAllDetails(f)">
      <!-- <app-svg-icon
          [src]="'./assets/SVGIcons/Clearicon.svg'"
          class="m-r-5"
          ></app-svg-icon> -->
        <app-svg-icon 
        class="" 
        [src]="'./assets/SVGIcons/Clearicon.svg'" class="h-33px">
        </app-svg-icon>
        <span class="px-2 clear-color"
          >Clear Details</span
        >
      </div>
     </div>
     
     <div class="modal-body">
      <form  class="theme-form needs-validation novalidate" #f="ngForm"  novalidate  >
        <div class="mb-3 pb-3">
        <app-dropdown
        [selectLabel]="generalInfoLables?.CERTIFICATIONS"
        [data]="certificationList"
        [selectValue]="certification?.Id"
        [ngClass]="{'border-red': !certification.Id && submit }"
        (selectValueEmit)="certification.Id = $event"
        [required]="true">
      </app-dropdown>
      </div>
      <div class="mb-3 pb-3">
        <app-date-picker
        [time]="false"
        [inputLabel]="'Date Issued'"
        [inputValue]="dateIssued"
        (inputValueEmit)="dateIssued = $event"
        [ngClass]="{'border-red':!dateIssued && submit}"
        [inputReqValidation]="true"

      ></app-date-picker>

      </div>
        <!-- <app-date-picker
        [time]="false"
        [inputLabel]="'Expiration Date'"
        [inputValue]="expirationDate"
        (inputValueEmit)="expirationDate = $event"
        [ngClass]="{'border-red':!expirationDate && submit}"
        [inputReqValidation]="true"

      ></app-date-picker> -->
      <app-date-picker class="addCertification"
      [time]="false"
      [inputLabel]="'Expiration Date'"
      [inputValue]="expirationDate"
      (inputValueEmit)="expirationDate = $event"
      [ngClass]="{'border-red':!expirationDate && submit}"
      [inputReqValidation]="true"

    ></app-date-picker>
   </form>       
  </div>
  <div class="modal-footer border-0 justify-content-between">
      <div class="m-0 d-flex">
          <app-button
          class=""
          [buttonType]="'button'"
          [button_2]="true"
          [buttonClass]="'button button-primary popup-button'"
          (click)="openUploadFilePopups()"
          [buttonLable]="enumButtonName.UPLOAD">
      </app-button>
      </div>
      <div class="m-0 d-flex justify-content-end gap-3">
      <app-button
      class=""
      [buttonType]="'button'"
      [button_2]="true"
      [buttonClass]="'button button-info popup-button'"
      (click)="activeModal.close()"
      [buttonLable]="enumButtonName.CANCEL">
      </app-button>
       <app-button
      class=""
      [buttonType]="'submit'"
      [button_2]="true"
      (click)="isAddValue ? editCertification(): addCertification()"
      [buttonClass]="'button button-primary popup-button'"
      [buttonLable]="isAddValue ? enumButtonName.UPDATE : enumButtonName.ADD"
       >
  </app-button>
    </div>
  </div>
</div>